import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import { propTypes, defaultProps } from './Slider.types.js';
import styles from './Slider.module.scss.js';

var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slider.prototype.render = function () {
        var _a = this.props, leftLabel = _a.leftLabel, rightLabel = _a.rightLabel, className = _a.className, withBackground = _a.withBackground, inputProps = __rest(_a, ["leftLabel", "rightLabel", "className", "withBackground"]);
        return (React__default.createElement("div", { className: styles.SliderWrapper + " " + (className || '') + " " + (withBackground ? styles.SliderWrapper___background : '') },
            leftLabel && (React__default.createElement("span", { className: styles.SliderLabel }, leftLabel)),
            React__default.createElement("input", __assign({ className: styles.Slider, type: "range" }, inputProps)),
            rightLabel && (React__default.createElement("span", { className: styles.SliderLabel }, rightLabel))));
    };
    Slider.displayName = 'Slider';
    Slider.propTypes = propTypes;
    Slider.defaultProps = __assign({}, defaultProps);
    return Slider;
}(React__default.Component));

export { Slider as default };
